var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var SecondaryHeading = /** @class */ (function (_super) {
    __extends(SecondaryHeading, _super);
    function SecondaryHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecondaryHeading.prototype.render = function () {
        return (React.createElement("h4", { className: "rj-ev-list__sub-heading " + ("rj-ev-list__sub-heading--" + this.props.cardType.toLowerCase()), "data-uat": "div-ev-list-sub-heading" }, this.props.children));
    };
    return SecondaryHeading;
}(React.PureComponent));
export { SecondaryHeading };
//# sourceMappingURL=SecondaryHeading.js.map